import React from "react";
import { PartnerDropdownCommon } from "./";

interface PartnerDropdownProps {
  componentLabel?: string;
  defaultValue?: string | string[];
  currentTeam?: string;
  required?: boolean;
  multiple?: boolean;
  visualStyle?: "autoComplete" | "autoCompleteMulti" | "simple" | "old";
  onChange?: (_event: any) => void;
}

/**
 * Partner dropdown component
 * @param {object} props props
 * @returns {Element} React Component
 * @class
 */
export function PartnerDropdown(props: PartnerDropdownProps) {
  const dropdownProps: any = {
    componentLabel: props.componentLabel,
    defaultValue: props.defaultValue,
    multiple: props.multiple,
    visualStyle: props.multiple
      ? "autoCompleteMulti"
      : props.visualStyle || "autoComplete",
    onChange: props.onChange,
  };

  if (props.required) {
    dropdownProps.required = props.required;
  }

  return <PartnerDropdownCommon {...dropdownProps} />;
}
